export default "__VITE_ASSET__HbYq9w_6__"